module.exports = __webpack_public_path__ + "assets/images/dashboard_purple.svg?ca361b55af43ab12b442c73b64fe88aa";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/dashboard_purple.svg
// module id = 620
// module chunks = 0